export const sAPIBASEURL = process.env.REACT_APP_CHATREL_API_BASE_URL
export const sAdminEmail = 'chatrelonline@tibet.net'
export const sDateFormat = 'DD-MM-YYYY'
export const sDateFormatMoment = 'YYYY-MM-DD'
export const sDateFormatMUIDatepicker = 'dd-MM-yyyy'
export const userRegistrationFormLink = process.env.REACT_APP_USER_REGISTRATION_FORM_URL
